import { useEffect, useRef, useState } from 'react';
import { webapi } from '@spot-fe/utils';

// deadpool 项目名称
export const PROJECT: Record<string, string> = {
  spot: 'bybit.spot.fe',
};

// deadpool keys
export const DEADPOOLKEYS: Record<string, string> = {
  launchpoolGray: 'launchpoolGray', // launchpool 降级
  depositEarnGray: 'depositEarnGray', // token splash 降级
  bystarterGray: 'bystarterGray', // bystarter 降级
  launchpadGray: 'launchpadGray', // launchpad 降级
  airdropHuntGray: 'airdropHuntGray', // airdropHunt 降级
};

// 当前开关key
export function useDeadpool(key) {
  const [isDeadpoolReady, setIsDeadpoolReady] = useState(false);
  const [isGray, setIsGray] = useState(false);

  // 转换接口返回值
  const getVal = (val: any) => !!Number(val);
  
  const getGary = async() => {
    const params = {
      project_name: PROJECT.spot,
      keys: [
        key,
      ],
    };
    try {
      
      const res: any = await webapi.post('/v3/config/web', params);
      const { success, result } = res;

      if (success) {
        (result?.data ?? []).forEach((item) => {
          switch (item.name) {
            case key:
              setIsGray(getVal(item?.value));
              break;

            default:
              break;
          }
        });
      }

      setIsDeadpoolReady(true);
    } catch {
      setIsDeadpoolReady(true);
    }
  };
  useEffect(() => {
    if (!key || isDeadpoolReady) {
      return;
    }

    getGary();
  }, [key, isDeadpoolReady]);
  return {
    isDeadpoolReady, // 接口是否完成
    isGray, // 当前key 的灰度
  };
}
